module.exports = __webpack_public_path__ + "img/image (10).c8950540.jpg";